/**
 * useAuth Custom Hook
 *
 * Provides access to authentication context throughout the application
 */

import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../context/AuthContext';

/**
 * Custom hook to access authentication context
 *
 * @returns AuthContextType - Authentication state and methods
 * @throws Error if used outside AuthProvider
 *
 * @example
 * ```typescript
 * const { isAuthenticated, user, login, logout } = useAuth();
 *
 * if (isAuthenticated) {
 *   console.log('User:', user?.email);
 * }
 * ```
 */
export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
